import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/thumbUpAction.svg';

export const IconThumbUpAction = createIconComponent(Icon);
